import { LockKey } from "phosphor-react";
import { InputWithLabelErrorPrefix } from "./Shared";

export function PasswordInput({ value, setValue, isLoading }) {
  return (
    <InputWithLabelErrorPrefix
      type="password"
      value={value}
      label="Password"
      id="password"
      placeholder="Password"
      prefix={<LockKey size={16} />}
      required={true}
      disabled={isLoading}
      error={() => ""}
      onChange={(e) => setValue(e.target.value)}
      width="100%"
      labelTop
    />
  );
}
